module.exports = __webpack_public_path__ + "media/images/logo-black-circle-small-a3646dab62189fa0e05caa1b4647ead6.png";